
export const DISABLED_MENU_ITEMS = [
    'EOTTS Benchmarking',
    'P&L Reconciliation',
    'Profitable Service',
    'Waste Benchmarking'
  ];
  